import './it-activity.css';
import { Header } from "../../components/widgets/header/header";
import { smoothScroll } from "../index/smooth-scroll";

export function initItActivityPage() {
  Header.init();
  smoothScroll.init();
}
